module.exports = __webpack_public_path__ + "static/img/coins.852bcd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins.jpg
// module id = geqS
// module chunks = 1